import { render, staticRenderFns } from "./errorMessage.vue?vue&type=template&id=b5ab383a&scoped=true"
import script from "./errorMessage.vue?vue&type=script&lang=js"
export * from "./errorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ab383a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ab383a')) {
      api.createRecord('b5ab383a', component.options)
    } else {
      api.reload('b5ab383a', component.options)
    }
    module.hot.accept("./errorMessage.vue?vue&type=template&id=b5ab383a&scoped=true", function () {
      api.rerender('b5ab383a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/errorMessage.vue"
export default component.exports